// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import type { ReactNode } from 'react';

import { View, Image } from '@react-pdf/renderer';

import atpLogo from '../assets/atp-logo.png';
import { basePdfStyles } from '../styles';

export function PdfHeader({ children }: { children?: ReactNode }) {
  const { rowView, mb3, logoWrapper, logo } = basePdfStyles;

  return (
    <View style={[rowView, mb3]}>
      <View style={logoWrapper}>
        <Image style={{ logo }} src={atpLogo} />
      </View>
      {children}
    </View>
  );
}
